/**
 * Couleurs sémantiques EkynAir — conformité WCAG AA/AAA sur fond clair.
 * Pourquoi : les hex vifs (#10B981, #F59E0B, #EF4444) échouent au
 * contraste AA quand utilisés en color: sur texte. Ces tokens fournissent
 * la version foncée à utiliser systématiquement pour les labels, valeurs,
 * badges et bordures sémantiques visibles sur fond clair.
 *
 * Règle : ne jamais utiliser les *Solid en color: sur du texte.
 * Les *Solid restent réservés aux backgrounds + texte blanc dessus,
 * aux icônes décoratives Chart.js, aux séries de graphique.
 */
export const semanticColors = {
  // Texte sémantique sur fond clair (AAA)
  greenText:  '#047857',  // 6.09:1 sur blanc
  amberText:  '#B45309',  // 5.93:1 sur blanc
  orangeText: '#C2410C',  // 6.43:1 sur blanc
  redText:    '#B91C1C',  // 7.05:1 sur blanc

  // Backgrounds tints (inchangés, à utiliser avec *Text dessus)
  greenBg:  '#D1FAE5',
  amberBg:  '#FEF3C7',
  redBg:    '#FEE2E2',

  // Solides à conserver pour borders épaisses + icônes décoratives
  // chart + backgrounds avec texte blanc (NE PAS utiliser en color: text)
  greenSolid:  '#10B981',
  amberSolid:  '#F59E0B',
  redSolid:    '#EF4444',  // ex-orangeSolid : #EF4444 est un rouge (red-500), pas un orange
  orangeSolid: '#F97316',

  // Teintes foncées pour texte posé SUR un fond *Bg (pas sur blanc) :
  // greenText / orangeText tombent sous 5:1 sur leur propre tint.
  greenTextStrong:  '#065F46',  // 6.78:1 sur greenBg
  orangeTextStrong: '#9A3412',  // 6.38:1 sur orangeBg
  orangeBg:         '#FFEDD5',

  // Neutre : états sans signal (hors ligne, jamais connecté, inconnu)
  neutralText:  '#4B5563',  // 6.87:1 sur neutralBg, 7.56:1 sur blanc
  neutralBg:    '#F3F4F6',
  neutralSolid: '#9CA3AF',

  // Tint de marque (fond d'avatar sans photo)
  blueBg: '#E8F0FE',
};

/**
 * Équivalents mode sombre (cartes sur dark.surface #282845) : fond teinté
 * foncé + texte clair. Ratios texte/fond ≥ 6.9:1, texte/surface ≥ 10.4:1.
 */
export const semanticColorsDark = {
  greenText:    '#A7F3D0',  // 7.58:1 sur greenBg
  greenBg:      '#064E3B',
  greenSolid:   '#34D399',
  orangeText:   '#FED7AA',  // 6.92:1 sur orangeBg
  orangeBg:     '#7C2D12',
  orangeSolid:  '#FB923C',
  neutralText:  '#E5E7EB',  // 8.17:1 sur neutralBg
  neutralBg:    '#3F3F5C',
  neutralSolid: '#9CA3AF',
};
